module.exports = __webpack_public_path__ + "img/qa.269b754e.svg";